import { useSelector } from 'react-redux';
import { urlStateToWebUrl, webUrlToUrlState, PageType } from '@westwing/looks-url-service';
import { useLooksTracking } from './useLooksTracking';
import { NewFilterValues, FilterTypes, Filter, AppliedFilter } from 'Client/components/Generic/FilterAndSortBox/types';
import useBellaPush from 'Client/hooks/useBellaHistoryPush';
import useRouter from 'Client/hooks/useRouter';
import { TrackLooksActions } from 'Common/ga/types';
import useTranslator from 'Client/hooks/useTranslator';
import { NewAppliedFilterItem } from 'Client/components/Generic/AppliedFilters/AppliedFiltersSlider';
import StateInterface from 'Client/redux/types';
import { StyleFilterEntry } from 'Client/redux/looksPage/types';

export const useFilterState = () => {
    const {
        location: { pathname },
    } = useRouter();
    const t = useTranslator();
    const bellaPush = useBellaPush();
    const { LLP: LLPTracking } = useLooksTracking();
    const { rooms, styles } = webUrlToUrlState(pathname);
    const filtersStyles = useSelector<StateInterface, StyleFilterEntry[]>(
        state => state.looksPage.looks.filters.styles
    );

    const onFilterValueChange = (changeFilter: NewFilterValues): void => {
        const { value, name } = changeFilter;
        const currentValue = Array.isArray(value) ? value : [value];
        const [first] = currentValue;
        if (name === 'room') {
            bellaPush(urlStateToWebUrl({ pageType: PageType.LLP, rooms: currentValue, styles }));
            return;
        }
        LLPTracking.track(TrackLooksActions.LLPFilterActivated, first);
        bellaPush(urlStateToWebUrl({ pageType: PageType.LLP, rooms, styles: currentValue }));
    };

    const clearRoomsFilter = () => {
        bellaPush(urlStateToWebUrl({ pageType: PageType.LLP, rooms: [], styles }));
    };

    const clearStylesFilter = () => {
        bellaPush(urlStateToWebUrl({ pageType: PageType.LLP, rooms, styles: [] }));
    };

    const styleFilter: Filter = {
        displayName: t('LLP_Style_Filter'),
        name: 'style',
        type: FilterTypes.multiRange,
        values: filtersStyles.reduce((result, item) => ({ ...result, [item.name]: item.name }), {}),
        valueKeys: filtersStyles.reduce((result, item) => ({ ...result, [item.name]: item.slug }), {}),
    };

    const appliedStyleFilter: AppliedFilter = { name: 'style', type: 'looks', values: styles || [] };
    const appliedStyleFiltersItems: NewAppliedFilterItem[] = (styles || []).map(style => ({
        filter: 'style',
        name: style,
        value: style,
    }));

    return {
        onFilterValueChange,
        clearRoomsFilter,
        clearStylesFilter,
        styleFilter,
        appliedStyleFilter,
        appliedStyleFiltersItems,
    };
};
